import _each from "lodash/each";
import _pullAt from "lodash/pullAt";
import store from "~/js/store/store";
import { gsap, Quint, Circ, Cubic, Linear } from "gsap";
import Common from "~/js/common/common";
import { EffectFade, Autoplay, Navigation, Pagination, Swiper, Scrollbar } from "swiper";

export default class Carousel {
  constructor() {
    this.setup();
  }
  setup() {
    const carousels = document.querySelectorAll(".js-carousel");
    this.tweens = [];
    //let carousel = new Swiper('.js-carousel')
    _each(carousels, (elm, index) => {
      let type = elm.getAttribute("data-type");
      if (type === "store-items") {
        this.createStoreItems(elm, index);
      } else {
        this.createSwiper(elm, "jsCarousel_" + index);
      }
    });
  }

  createSwiper(elm, name) {
    const effect = elm.getAttribute("data-effect") || "fade";
    const pagination = elm.querySelector(".js-carousel-pagination") || "";
    let navigation;
    let autoplay = false;
    let modules = [EffectFade, Pagination];
    let speed = 1200;
    if (elm.getAttribute("data-autoplay")) {
      autoplay = {
        delay: 5200,
        disableOnInteraction: false,
        waitForTransition: false,
        stopOnLastSlide: false
      };
      speed = elm.getAttribute("data-speed") || 1500;
      modules.push(Autoplay);
    }
    if (elm.getAttribute("data-navigation")) {
      navigation = {
        prevEl: elm.querySelector(".js-navigation-prev"),
        nextEl: elm.querySelector(".js-navigation-next")
      };
      modules.push(Navigation);
    }
    const options = {
      effect: effect,
      autoplay: autoplay,
      speed: speed,
      loop: true,
      slidesPerGroup: 1,
      slidesPerView: 1,
      modules: modules,
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: pagination,
        clickable: true,
        bulletElement: "button",
        type: "custom",
        renderCustom: (swiper, current, total) => {
          let result = "";
          for (let i = 1; i <= total; ++i) {
            let _class = "swiper-pagination-bullet";
            _class += " swiper" + i;
            let svg = "<svg viewBox='0 0 20 20' fill='none'><circle cx='10' cy='10' r='8' stroke='#333333' stroke-width='4' class='js-circle'/></svg>";
            if (i === current) {
              _class += " swiper-pagination-bullet-active";
            }
            result += "<button class='" + _class + "' aria-label='" + i + "' tabindex='1' role='button'>" + svg + "</button>";
          }
          return result;
        }
      },
      navigation,
      on: {
        slideChange: (swiper, progress) => {
          if (autoplay) {
            //5.2
            this.updateProgress(5.2, progress, elm, name, swiper);
          }
          // カルーセルの非表示になっている部分も読み上げられないように対応
          // img が無い（動画のみ等）場合や、img 数とスライド数が一致しない場合でも例外を出さない
          if (imgs && imgs.length) {
            const currentSlide = swiper.slides[swiper.activeIndex];
            for (var i = 0; i < imgs.length; i++) {
              imgs[i].setAttribute("alt", currentSlide && currentSlide.contains(imgs[i]) ? alt[i] : "");
            }
          }
        }
      }
    };
    let carousel = new Swiper(elm.querySelector(".swiper"), options);

    // カルーセルの非表示になっている部分も読み上げられないように対応
    const imgs = elm.querySelectorAll("img");
    let alt = [];
    for (var i = 0; i < imgs.length; i++) {
      alt[i] = imgs[i].getAttribute("alt") || "";
    }
  }

  updateProgress(autoplayTime, progress, elm, name, swiper) {
    let obj = {
      time: 0
    };
    if (this.tweens) {
      let _index;
      _each(this.tweens, (tw, i) => {
        if (tw.name === name) {
          tw.tween.kill();
          _index = i;
        }
      });
      _pullAt(this.tweens, _index);
    }
    let tween = {
      name: name
    };
    this.resetCircleIndicator(elm);
    tween.tween = gsap.to(obj, {
      time: 50,
      delay: 0,
      duration: autoplayTime,
      ease: Linear.easeNone,
      overwrite: true,
      onUpdate: () => {
        this.updateCircleIndicator(obj.time, swiper.realIndex + 1, elm);
      }
    });
    this.tweens.push(tween);
  }

  resetCircleIndicator(elm) {
    const circles = elm.querySelectorAll(".js-circle");
    _each(circles, (circle) => {
      gsap.set(circle, {
        "stroke-dashoffset": 100
      });
    });
  }

  // 自動再生インジケーターの更新
  updateCircleIndicator(time, currentIndex, elm) {
    const targetCircle = elm.querySelector(".swiper" + currentIndex + " circle");
    //let targetCircle = circles[currentIndex];
    if (targetCircle) {
      gsap.set(targetCircle, {
        "stroke-dashoffset": 100 - time
      });
    }
  }

  /*createLookMvSwiper(elm) {
    const next = elm.getAttribute("data-next") || "";
    const prev = elm.getAttribute("data-prev") || "";
    const pagination = elm.getAttribute("data-pagination") || "";
    const options = {
      effect: "fade",
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        stopOnLastSlide: false
      },
      speed: 1200,
      loop: true,
      modules: [Autoplay, EffectFade, Navigation, Pagination],
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        prevEl: document.querySelector(prev),
        nextEl: document.querySelector(next)
      },
      pagination: {
        el: pagination,
        type: "custom",
        renderCustom: (swiper, current, total) => {
          return "<span>" + Common.addZero(current) + "</span> / " + Common.addZero(total);
        }
      }
    };
  }*/

  /**
   * オンラインストア取り扱いアイテム, ピックアップアイテム（ECページ）用
   * @param elm
   */
  createStoreItems(elm, index) {
    let prev = elm.querySelector(".c-carousel-item-prev");
    let next = elm.querySelector(".c-carousel-item-next");
    let swipers = elm.querySelector(".swiper");
    let slides = elm.querySelectorAll(".swiper-slide");
    if (!Common.isSPSize()) {
      if (slides.length < 4) {
        swipers.classList.add("type-center");
      }
    }
    const options = {
      speed: 600,
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 10,
      loop: false,
      modules: [Autoplay, Navigation, Scrollbar],
      breakpoints: {
        768: {
          slidesPerView: 4,
          slidesPerGroup: 1,
          //slidesPerGroup: 4,
          spaceBetween: 16
        }
      },
      navigation: {
        prevEl: prev,
        nextEl: next
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true
      }
    };
    let carousel = new Swiper(swipers, options);
  }
}
